export const drawerAnimation = {
    variants: {
        hidden: {
            x: '100vh',
        },
        visible: {
            x: 0,
        },
    },
    transition: { type: 'tween', duration: 0.35, ease: 'linear' },
    initial: 'hidden',
    animate: 'visible',
    exit: 'hidden',
};
